import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'react-bootstrap';
import { Controller } from 'react-hook-form';
import { getThemes } from 'api/company';
import SelectCustom from 'components/backoffice/selects/SelectCustom';
import Button from 'components/backoffice/buttonCustom';
import ThemeModal from 'components/backoffice/modals/ThemeModal';
import SpinnerComponent from 'components/backoffice/SpinnerComponent';

const ThemeSelector = ({
  control,
  name = 'theme',
  label,
  placeholder,
  onThemeChange,
  defaultValue = ''
}) => {
  const { t } = useTranslation(['backoffice']);
  const [themes, setThemes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedTheme, setSelectedTheme] = useState(defaultValue);

  useEffect(() => {
    loadThemes();
  }, []);

  const loadThemes = async () => {
    setLoading(true);
    try {
      const response = await getThemes();
      if (response.status === 200) {
        setThemes(response.data.results || response.data || []);
      }
    } catch (error) {
      console.error('Error al cargar los temas:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleThemeCreated = (newTheme) => {
    loadThemes();
    setSelectedTheme(newTheme.id);
    if (onThemeChange) {
      onThemeChange(newTheme);
    }
  };

  const handleThemeSelect = (themeId) => {
    setSelectedTheme(themeId);
    const selectedThemeData = themes.find(theme => theme.id === themeId);
    if (onThemeChange && selectedThemeData) {
      onThemeChange(selectedThemeData);
    }
  };


  return (
    <Col sm={12} md={12} lg={12} xl={8} className="mt-4 mt-xl-0 mb-md-2 mb-lg-0 d-flex flex-row justify-content-between px-3 pb-2 border border-light">
      <div className="d-flex align-items-start w-50 pe-3">
        <Controller
          name={name}
          control={control}
          render={({ field: { onChange, value } }) => (
            <SelectCustom
              label={label || t('themes.theme')}
              placeholder={placeholder || t('themes.selectTheme')}
              value={value || selectedTheme}
              onCheckedItem={(selectedValue) => {
                onChange(selectedValue);
                handleThemeSelect(selectedValue);
              }}
              choices={themes.map(theme => ({
                id: theme.id,
                value: theme.name
              }))}
            />
          )}
        />
        {loading && <SpinnerComponent loading={loading} />}
      </div>
      <div className="d-flex align-items-end w-50">
        <Button
          type="button"
          color="primary"
          onClick={() => setShowModal(true)}
          className="w-100 btn-intra bg-primary-color ms-3"
        >
          {t('themes.addNewTheme')}
        </Button>
      </div>

      <ThemeModal
        show={showModal}
        onHide={() => setShowModal(false)}
        onThemeCreated={handleThemeCreated}
        loading={loading}
      />
    </Col>
  );
};

ThemeSelector.propTypes = {
  control: PropTypes.object.isRequired,
  name: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  onThemeChange: PropTypes.func,
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default ThemeSelector;
